import { IconComponentsProps } from './types';

const PendingIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg
    fill={fill}
    width="16px"
    height="16px"
    viewBox="0 0 32 32"
    id="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9" cy="16" r="2" />
    <circle cx="23" cy="16" r="2" />
    <circle cx="16" cy="16" r="2" />
    <path
      d="M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
      transform="translate(0 0)"
    />
  </svg>
);

export default PendingIcon;
